import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState, memo } from 'react';
import { FormikProps } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersProcessingJob } from 'system/pages/processing-job/list/types';
import StateList from './state-list';
import { DateTimePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import { ItemVM } from 'shell/view-models/item';
import SearchBatchList from 'system/components/shared/search-batch-list';
import { SearchField } from 'system/components/shared/search-batch-list/constants';
import { JobVM } from 'system/view-models/batch-managment/job-vm';

interface FiltersProcessingJobProps {
  filterBatchForm: FormikProps<FiltersProcessingJob>;
}

const FilterProcessingJobComponent = ({
  filterBatchForm,
}: FiltersProcessingJobProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-job-content"
        id="panel-job-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterBatchForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <SearchBatchList
                searchField={SearchField.JOB_NAME}
                value={filterBatchForm.values.batchName || null}
                onChange={(item: JobVM | null) => filterBatchForm.setFieldValue('batchName', item)}
                error={
                  filterBatchForm.touched.batchName && Boolean(filterBatchForm.errors.batchName)
                }
                helperText={filterBatchForm.errors?.batchName}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <StateList
                value={filterBatchForm.values.state?.id?.toString() || ''}
                onChange={(val: ItemVM | undefined) => filterBatchForm.setFieldValue('state', val)}
                error={filterBatchForm.touched.state && Boolean(filterBatchForm.errors.state)}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DateTimePicker
                label="Data e ora inizio da"
                value={filterBatchForm.values.startedAtFrom || null}
                onChange={(date) => filterBatchForm.setFieldValue('startedAtFrom', date)}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    fullWidth
                    error={
                      filterBatchForm.touched.startedAtFrom &&
                      Boolean(filterBatchForm.errors.startedAtFrom)
                    }
                    helperText={filterBatchForm.errors.startedAtFrom}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DateTimePicker
                label="Data e ora a"
                value={filterBatchForm.values.startedAtTo || null}
                onChange={(date) => filterBatchForm.setFieldValue('startedAtTo', date)}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    fullWidth
                    error={
                      filterBatchForm.touched.startedAtTo &&
                      Boolean(filterBatchForm.errors.startedAtTo)
                    }
                    helperText={filterBatchForm.errors.startedAtTo}
                  />
                )}
              />
            </Grid>
            <Grid item xs>
              <PmiButton variant="contained" color="secondary" type="submit">
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FilterProcessingJobComponent.displayName = 'Filters Batch management';

const FilterProcessingJob = memo(FilterProcessingJobComponent);

export default FilterProcessingJob;
